import { h, render, Component } from 'preact';
import { translate } from 'react-i18next';

class Branding extends Component {

	render() {
		return (
			<div className="branding-wrapper">
				<div className="image">
					<img src="https://webcdn.hirezstudios.com/account-services/logo-hirez.png" alt="Branding" />
				</div>
				<div className="copy">
					{/* TODO: Load dynamic messaging based upon brand or custom payload */}
				</div>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(Branding);


// WEBPACK FOOTER //
// ./components/LoginPanelBranding.js